import * as React from 'react'
import ReactS3Uploader, {
  type S3Response,
} from '../../integrations/react-s3-uploader/ReactS3Uploader'

export interface UploadZoneProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'children'> {
  accept: string
  onUploadComplete: (result: S3Response, file: File) => void
  onGetSigningUrl: (file: File, callback: (params: S3Response) => void) => void
  children: React.ReactNode | ((triggerUpload: () => void) => React.ReactNode)
  isLoading?: boolean
}

const UploadZone = React.forwardRef<HTMLLabelElement, UploadZoneProps>(
  ({ accept, children, onUploadComplete, onGetSigningUrl, isLoading }, ref) => {
    const uploaderRef = React.useRef<HTMLInputElement>(null)

    const triggerUpload = React.useCallback(() => {
      uploaderRef.current?.click()
    }, [])

    const renderedChildren =
      typeof children === 'function' ? children(triggerUpload) : children

    return (
      <div className="w-full flex items-center gap-4 justify-between cursor-pointer">
        {!isLoading && (
          <ReactS3Uploader
            getSignedUrl={onGetSigningUrl}
            onFinish={onUploadComplete}
            onError={(err) => console.error(err)}
            contentDisposition="auto"
            accept={accept}
            uploadRequestHeaders={{}}
            className="hidden"
            ref={uploaderRef}
            inputRef={uploaderRef as React.RefObject<HTMLInputElement>}
          />
        )}
        {renderedChildren}
      </div>
    )
  },
)
UploadZone.displayName = 'UploadZone'

export { UploadZone }
